import React, { useState, useEffect, useRef } from 'react'
import {
    Button,
    Input, Affix, message, Modal,
    Divider,
} from 'antd'
import InfiniteScroll from 'react-infinite-scroller';
import AutoResponsive from './components/AutoResponsive'
import TagsDrawer from './components/TagsDrawer'
import { fetchInsAllTag, updateInsImgTag, popDetail, sensitiveWord, listByInsIds, listByWord, batchDelIns } from '../../../api/inspiration';
import './index.less'

const { confirm } = Modal

export default () => {
    const reload = useRef(false)
    const [word, setWord] = useState('客厅')
    const [ids, setIds] = useState('')
    const [canShield, setCanShield] = useState(false)
    const [checkAll, setCheckAll] = useState(false)
    const [popData, setPopData] = useState({})
    const [onSearchIds, setOnSearchIds] = useState(false)
    const [state, setState] = useState({
        fetching: false,
        page: 1,
        count: 1,
        hasMore: true,
        list: [],
    });
    // 编辑标签抽屉
    const [editTagsDrawer, setEditTagsDrawer] = useState(false)
    // insId
    const [insId, setInsId] = useState(null)
    // 分类标签
    const [classifyWord, setClassifyWord] = useState('')
    // 属性标签
    const [attrWordList, setAttrWordList] = useState([])
    // 补充标签
    const [supplementWordList, setSupplementWordList] = useState([])

    useEffect(() => {
        if (reload) {
            reload.current = false
            loadFunc()
        }
    }, [reload.current])

    const loadFunc = async () => {
        const { page, list, count, hasMore, fetching } = state;
        if (!hasMore || fetching) return;
        await setState({
            ...state,
            fetching: true,
        });
        let res = null
        if (onSearchIds) {
            res = await listByInsIds(ids.split(','))
        } else {
            res = await listByWord({
                page: page,
                pageSize: 100,
                keyword: word
            })
        }
        setState({
            ...state,
            page: state.page + 1,
            fetching: false,
            hasMore: onSearchIds ? false : res?.data?.inspirations?.length,
            list: [...list, ...(res?.data?.inspirations ?? [])],
        });
        setCanShield(res?.data?.isSensitive)
        if (ids) {
            setCanShield(true)
        }
    };

    const handleInputChange = (e) => {
        setWord(e.target.value)
    }

    const handleIdsChange = (e) => {
        setIds(e.target.value)
    }

    const onChange = (i, v) => {
        const { list } = state
        const insIds = list.filter(v => v.checked && !v.delete).map(v => v.insId)
        if (!insIds.length) {
            goFetchInsAllTag(v.insId)
            setEditTagsDrawer(true)
        } else {
            setEditTagsDrawer(false)
        }
        const newList = [...state.list]
        newList[i].checked = !newList[i].checked
        setState({
            ...state,
            list: newList
        })
    }

    const onCheckAll = () => {
        const newList = [...state.list]
        setCheckAll(!checkAll)
        newList.map(v => v.checked = !checkAll)
        setState({
            ...state,
            list: newList
        })
    }

    const clearAll = () => {
        setWord('');
        setIds('');
        setState({
            fetching: false,
            page: 1,
            count: 1,
            hasMore: true,
            list: [],
        });
    };

    const onSearch = () => {
        if (!word && !ids) {
            message.info('请输入搜索词或id')
            return
        }
        setState({
            fetching: false,
            page: 1,
            count: 1,
            hasMore: true,
            list: [],
        })
        setOnSearchIds(ids.length)
        reload.current = true
    }

    const addSensitiveWord = async () => {
        if (!word) {
            message.info('请输入搜索词')
            return
        }
        const res = await sensitiveWord(word)
        if (res.error.code == 0) {
            message.success('搜索词屏蔽成功')
        } else {
            message.error(res.error.message)
        }
    }

    const onVisibleChange = async (insId) => {
        const res = await popDetail(insId)
        setPopData(res.data)
    }

    const onDel = async () => {
        confirm({
            title: '确认删除?',
            cancelText: '取消',
            okText: '确定',
            async onOk() {
                const { list } = state
                const insIds = list.filter(v => v.checked && !v.delete).map(v => v.insId)
                if (!insIds.length) {
                    message.info('没有选中图片')
                    return
                }
                const res = await batchDelIns(insIds)
                if (res.error.code == 0) {
                    if (res.data?.crawlList?.length) {
                        message.warning(`图片ID ${res.data.crawlList.join(',')}为用户采集图片,系统无法删除`)
                    }
                    message.success('删除完毕')
                    const newList = list.map(v => {
                        return {
                            ...v,
                            delete: res.data?.crawlList?.indexOf(v.insId) == -1 ? v.checked : false
                        }
                    })
                    setState({
                        ...state,
                        list: newList
                    })
                } else {
                    message.error(res.error.message)
                }
            },
            onCancel() {
                console.log('Cancel');
            },
        })
    }
    // 打开标签编辑抽屉
    const showDrawer = () => {
        setEditTagsDrawer(true);
    };

    // 关闭标签编辑抽屉
    const onClose = () => {
        setEditTagsDrawer(false);
        setClassifyWord('')
        setAttrWordList([])
        setSupplementWordList([])
    };

    // 获取图片分类属性和补充标签
    const goFetchInsAllTag = async insId => {
        const res = await fetchInsAllTag(insId)
        if (res?.error?.code == 0 && res?.data) {
            setInsId(insId)
            setClassifyWord(res.data?.classifyWord)
            setAttrWordList(res.data?.attrWordList)
            setSupplementWordList(res.data?.supplementWordList)
        }
    }
    // 修改图片分类属性和补充标签
    const goUpdateInsImgTag = async (data) => {
        const res = await updateInsImgTag(data)
        if (res?.error?.code == 0 && !res?.data?.length) {
            message.success('修改成功')
            onClose()
        } else {
            message.error(`您选择的标签不符合图片入库规范，无法保存。错误可能存在于:${res?.data}`)
        }
    }

    return (
        <div className='imgQuality'>
            <div className='imgQualityHeader'>图片管理&gt;图片列表</div>
            <Affix>
                <div className='imgQualityOperation'>
                    <div className='top-recommend-searchArea'>
                        搜索词：
                        <Input
                            style={{ width: 200 }}
                            placeholder='客厅'
                            value={word}
                            onChange={handleInputChange}
                            onPressEnter={onSearch}
                        />
                    </div>
                    <div style={{ display: 'inline-block', width: 600 }}>
                        图片ID：
                        <Input
                            style={{ width: 400 }}
                            placeholder='可输入多个id 使用英文逗号隔开：123,456'
                            value={ids}
                            onChange={handleIdsChange}
                        />
                    </div>
                    <div style={{ display: 'inline-block', width: 100 }}>
                        <Button type='danger' onClick={clearAll}>清空</Button>
                    </div>
                    <div style={{ display: 'inline-block', width: 100 }}>
                        <Button type="primary" onClick={onSearch}>查询</Button>
                    </div>
                    {/* <div style={{ display: 'inline-block', width: 100 }}>
                        <Button onClick={onCheckAll}>{checkAll ? '取消' : ''}全选</Button>
                    </div> */}
                    <Divider />
                    {/* <div style={{ display: 'inline-block', width: 200 }}>
                        <Button type="danger" disabled={canShield} onClick={addSensitiveWord}>屏蔽此搜索结果</Button>
                    </div> */}
                    <div style={{ display: 'inline-block', width: 100 }}>
                        <Button type="danger" onClick={onDel}>删除图片</Button>
                    </div>
                </div>
            </Affix>
            <div style={{ width: 1660 }}>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={loadFunc}
                    hasMore={state.hasMore}
                    initialLoad={true}
                >
                    <AutoResponsive
                        popData={popData}
                        list={state.list}
                        containerWidth={1600}
                        itemWidth={246}
                        columnCount={6}
                        needResize={true}
                        onChange={onChange}
                        onVisibleChange={onVisibleChange} />
                </InfiniteScroll>
                {!state.list.length ? <div className="imgQualityEmpty">没有搜索结果哦 🔍</div> : null}
            </div>
            < TagsDrawer editTagsDrawer={editTagsDrawer} onClose={onClose} showDrawer={showDrawer} attrWordList={attrWordList} classifyWord={classifyWord} supplementWordList={supplementWordList} setClassifyWord={setClassifyWord} setSupplementWordList={setSupplementWordList} setAttrWordList={setAttrWordList} goUpdateInsImgTag={goUpdateInsImgTag} insId={insId}></TagsDrawer>
        </div >
    )
}